<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">
          System Level God Categories
          <a href="" target="_blank" class="ml-2">
            <vs-icon icon="info" size="small" />
          </a>
          <vs-button class="ml-auto" type="filled" icon="add_circle" size="small" @click="addingNewItem">Add New Music Category</vs-button>
        </h3>
        <p class="card-subtitle">List of God and Related Musics.</p>
        <vs-row>
          <vs-col vs-lg="3" vs-xs="12">
            <vs-select :color="colorx" label="Language Filter" @change="fileterusingLanguage($event)" v-model="search.language">
              <vs-select-item :key="index" :value="item.culture" :text="item.culture" v-for="(item, index) in languages" />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="3" vs-xs="12">
            <vs-select :color="colorx" label="Sorting Type" v-model="search.sort" @change="fileterusingSort($event)">
              <vs-select-item value text="Select Sorting" disabled />
              <vs-select-item value="1" text="Ascending" />
              <vs-select-item value="-1" text="Descending" />
            </vs-select>
          </vs-col>
          <!-- <vs-col vs-lg="3" vs-xs="12">
            <vs-select :color="colorx" label="Status Filter" v-model="search.status">
              <vs-select-item value text="Select Status" disabled />
              <vs-select-item value="0" text="All" />
              <vs-select-item value="1" text="Active" />
              <vs-select-item value="2" text="Inactive" />
            </vs-select>
          </vs-col> -->
          <vs-col vs-lg="3" vs-xs="12">
            <!-- <vs-button color="primary" type="filled" class="searchBtn" @click="searchData()">Search</vs-button> -->
            <vs-button color="warning" type="filled" class="searchBtn" @click="resetData()">Reset</vs-button>
            <vs-button color="success" type="filled" class="searchBtn" @click="sortPositions()">Sort</vs-button>
          </vs-col>
        </vs-row>
        <br />
        <table class="table">
          <tr>
            <th>#</th>
            <th></th>
            <th>Feature Image</th>
            <th>God Name</th>
            <th @click="sortBy('position')" style="cursor: pointer; text-align: center">
              Position
              <span v-if="sortByField === 'position'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
            </th>
            <th @click="sortBy('totalPlays')" style="cursor: pointer; text-align: center">
              Total Plays
              <span v-if="sortByField === 'totalPlays'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
            </th>
            <th @click="sortBy('recentPlays')" style="cursor: pointer; text-align: center">
              24h count
              <span v-if="sortByField === 'recentPlays'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
            </th>
            <th>Language</th>
            <!--  <th>Status</th>-->
            <th></th>
          </tr>
          <tr v-for="(item, index) in all" :key="item._id">
            <td>{{ index + 1 }}</td>
            <td>
              <img v-if="item.image == '' || item.image == null" src="../../../assets/images/No-image.png" height="50px" width="75px" />
              <img v-else :src="item.image" height="50px" width="75px" />
            </td>
            <td>
              <img v-if="item.featureImage == '' || item.featureImage == null" src="../../../assets/images/No-image.png" height="50px" width="75px" />
              <img v-else :src="item.featureImage" height="50px" width="75px" />
            </td>
            <td class="td">{{ item.name }}</td>
            <td class="td">
              <!-- add up and down arrows from react-icons -->
              <div style="display: flex; align-items: center; flex-direction: column; justify-content: center; gap: 0.5rem">
                <vs-button icon="arrow_upward" size="small" @click="updatePosition(item._id, search.sort === 1 ? 'up' : 'down')"></vs-button>
                {{ item.position }}
                <vs-button icon="arrow_downward" size="small" @click="updatePosition(item._id, search.sort === 1 ? 'down' : 'up')"></vs-button>
              </div>
            </td>
            <td class="td text-center" style="font-weight: bold; font-size: small">
              {{ getTotalPlays(item.totalPlays) }}
            </td>
            <td class="td text-center" style="font-weight: bold; font-size: small">
              {{ getTotalPlays(item.recentPlays) }}
            </td>
            <td class="td text-center">
              {{ item.language }}
              <div class="d-flex" v-if="search.language == 'EN' && item.languageCount">
                <div class="progress-bar-container mt-3">
                  <div
                    class="progress-bar p-2"
                    :style="{
                      color: item.languageCount - item.missingLanguages.length === item.languageCount ? 'white' : 'black',
                      backgroundColor: item.missingLanguages.length > 0 ? 'red' : item.missingLanguages.length > 1 ? '#06b800' : '',
                      width: ((item.languageCount - item.missingLanguages.length) / item.languageCount) * 100 + '%',
                    }"
                  >
                    <div class="absoluteText">{{ item.languageCount - item.missingLanguages.length }}/{{ item.languageCount }}</div>
                  </div>
                </div>
                <div class="text-center mt-2 d-flex align-items-center" style="font-weight: 800">
                  <div style="width: 20px; height: 20px; margin-left: 5px" v-popover:tooltip="item.tooltipContent">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="16" x2="12" y2="12"></line>
                      <line x1="12" y1="8" x2="12" y2="8"></line>
                    </svg>
                  </div>
                </div>
              </div>
            </td>
            <!--  <td class="td">
              <vs-chip v-if="item.status" color="success">Active</vs-chip>
              <vs-chip v-else color="danger">Inactive</vs-chip>
            </td>-->
            <td class="td">
              <vs-button class="mr15" size="small" color="warning" @click="editingItem(item, 'edit')">Edit</vs-button>
              <vs-button
                class="mr15"
                size="small"
                color="danger"
                @click="
                  deleteCategoryPopup = true;
                  itemToDelete = item;
                "
                >Delete</vs-button
              >
              <!-- <vs-button class="mr15 mb10" size="small" color="success"
                @click="editingItem(item, 'clone')">Duplicate</vs-button> -->
              <vs-button class="mr15" size="small" color="primary" @click="viewAllPosts(item)">View All Music</vs-button>
            </td>
          </tr>
        </table>

        <!-- Code -->
        <vs-popup :title="isNew ? 'Add New God' : clone ? 'Duplicate God' : 'Edit God'" :active.sync="defaultalert">
          <vs-row>
            <vs-col vs-lg="6" vs-xs="6">
              <vs-select
                :color="colorx"
                label="Category Language"
                @change="fileterusingLanguages($event, cat)"
                v-model="cat.language"
                icon="arrow_downward"
                :disabled="isNew == true || clone == true"
              >
                <vs-select-item value text="Choose Language" disabled />
                <vs-select-item :value="item.culture" :text="item.culture" v-for="(item, index) in languages" :key="index" />
              </vs-select>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="God Name (Keep it Simple and short)" v-model="cat.name" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" v-if="!isNew">
              <p class="mt-2" style="font-size: 0.85rem">Current Position: {{ cat.position }}</p>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="mt-4">
              <vs-checkbox v-model="cat.moveTop" @change="cat.moveBottom = false">Move to Top</vs-checkbox>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="mt-4">
              <vs-checkbox v-model="cat.moveBottom" @change="cat.moveTop = false">Move to Bottom</vs-checkbox>
            </vs-col>

            <!-- <vs-col vs-lg="6" vs-xs="6" class="mt-4">
               <vs-checkbox v-model="cat.status">Status (Active / Inactive)</vs-checkbox>
            </vs-col>-->
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12" v-if="displayImage == ''">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label">God Image Upload (Try to use square image)</label>
                    <div class="btn"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File</div>
                    <input type="file" ref="fileInput" @change="uploadImage($event, 'image')" />
                  </div>
                </vs-col>
                <vs-col v-if="displayImage">
                  <div>Image</div>
                  <vs-button color="danger" type="flat" icon="clear" class="closeBtn" @click="deleteImage()"></vs-button>
                  <img :src="displayImage" class="imgUp" height="100px" width="150px" />
                  <b>File Name : {{ fileName }}</b>
                </vs-col>
              </div>
              <!-- <uploader
                label="God Image Upload (Try to use square image)"
                v-model="cat.image"
                :file="cat.image"
              />-->
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12" v-if="featureImage == '' || !featureImage">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label">Feature Image Upload (Try to use square image)</label>
                    <div class="btn"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File</div>
                    <input type="file" ref="fileInput" @change="uploadImage($event, 'featureImage')" />
                  </div>
                </vs-col>
                <vs-col v-if="featureImage">
                  <div>Feature Image</div>
                  <vs-button color="danger" type="flat" icon="clear" class="closeBtn" @click="deleteFeatureImage()"></vs-button>
                  <img :src="featureImage" class="imgUp" height="100px" width="150px" />
                  <b>File Name : {{ fileName }}</b>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="9" vs-xs="12">
              <vs-button icon="save" @click="btnAddCategory">{{ isNew ? "Save English" : "Update one" }}</vs-button>
              <vs-button icon="save" class="ml-3" @click="createAndTranslate" v-if="isNew">Save and Translate</vs-button>
              <vs-button icon="save" class="ml-3" @click="updateAndTranslate" v-if="!isNew && !showLoader && !clone && cat.language === 'EN'"
                >Update all</vs-button
              >
              <vs-checkbox v-model="cat.translate" v-if="!isNew && !clone && cat.language === 'EN'" class="mt-2"> Update translations </vs-checkbox>
            </vs-col>
          </vs-row>
        </vs-popup>

        <vs-popup class="holamundo" title="Delete God Category" :active.sync="deleteCategoryPopup">
          <p>Are you sure you want to delete this God Category?</p>
          <div>
            <vs-button class="mr15" @click="deleteCategory">Delete God</vs-button>
            <vs-button @click="deleteCategoryPopup = false">Cancel</vs-button>
          </div>
        </vs-popup>
        <!-- Code -->
      </vs-card>
    </vs-col>
    <div v-if="showLoader" class="loader-container">
      <!-- show text that it is working in background. -->
      <div class="loader"></div>
      <vs-col vs-lg="12" vs-xs="1">
        <p class="loader-text">Translations are in progress.</p>
      </vs-col>
    </div>
    <tooltip :width="300" :pointer="true"> </tooltip>
  </vs-row>
</template>

<script>
// import uploader from "../common/uploader.vue";
import api from "@/rest.js";
import { API } from "@/common/constants";
import Vue from "vue";
import VPopover from "vue-js-popover";

Vue.use(VPopover, { tooltip: true });

export default {
  name: "Music",
  components: {
    // uploader,
  },
  data: () => ({
    title: "Music",
    colorx: "#0D2144",
    defaultalert: false,
    fileName: "",
    deleteCategoryPopup: false,
    isNew: true,
    clone: false,
    displayImage: "",
    featureImage: "",
    sortByField: "",
    sortDirection: "asc",
    sorting: 1,
    search: {
      sort: 1,
      language: "EN",
      status: "0",
    },
    cat: {
      // status: true,
      language: "",
      position: "",
      name: "",
      image: "",
      moveTop: false,
      moveBottom: false,
      translate: false,
    },
    itemToDelete: "",
    itemToUpdate: "",
    all: [],
    languages: [],
    englishData: {},
    showLoader: false,
  }),
  computed: {
    sortedData() {
      return this.all.sort((a, b) => {
        if (this.sortDirection === "asc") {
          return a[this.sortByField] - b[this.sortByField];
        } else {
          return b[this.sortByField] - a[this.sortByField];
        }
      });
    },
  },
  watch: {
    "cat.moveTop"(newValue) {
      if (newValue) {
        this.cat.moveBottom = false;
      }
    },
    "cat.moveBottom"(newValue) {
      if (newValue) {
        this.cat.moveTop = false;
      }
    },
  },
  methods: {
    getTotalPlays(totalPlays) {
      if (totalPlays >= 1000000) {
        return (totalPlays / 1000000).toFixed(1) + "M";
      } else if (totalPlays >= 1000) {
        return (totalPlays / 1000).toFixed(1) + "K";
      } else {
        return totalPlays;
      }
    },

    sortBy(field) {
      this.sortByField = field;
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      this.all = this.sortedData;
    },

    sortPositions() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      this.$vs.loading();
      api
        .put(`${API.GOD_SORT_POSITION}?language=${this.$data.search.language}`, {}, { headers })
        .then((r) => {
          this.$vs.loading.close();
          if (r.status === 200) {
            this.$vs.notify({
              text: "Sorted Successfully",
              color: "success",
              position: "top-right",
            });
            this.fetchAllCategory();
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            text: "Error Deleting",
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
        });
    },
    updatePosition(id, type) {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      this.$vs.loading();
      api
        .put(`${API.GOD_UPDATE_POSITION}/${id}?direction=${type}`, {}, { headers })
        .then((r) => {
          this.$vs.loading.close();
          if (r.status === 200) {
            this.$vs.notify({
              text: "Position Updated Successfully",
              color: "success",
              position: "top-right",
            });
            this.fetchAllCategory();
          }
        })
        .catch((e) => {
          this.$vs.notify({
            text: e.response.data.error,
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
        });
    },

    addingNewItem() {
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.displayImage = "";
      this.$data.featureImage = "";
      this.$data.cat = {
        status: true,
        language: "EN",
        position: "",
        name: "",
        image: "",
        moveTop: false,
        moveBottom: true,
        featureImage: "",
      };
    },
    editingItem(i, data) {
      this.$data.englishData = Object.assign({}, i);
      this.$data.cat = Object.assign({}, i);
      this.$data.defaultalert = true;
      this.$data.isNew = false;
      this.$data.displayImage = i.image;
      this.$data.featureImage = i.featureImage;
      var name = i.image.split("-");
      this.$data.fileName = name[name.length - 1];
      this.$data.clone = data == "clone" ? true : false;
    },
    btnAddCategory() {
      if (this.$data.displayImage == "") {
        this.$vs.notify({
          text: "God Image Require",
          color: "warning",
          position: "top-right",
        });
        return;
      }
      if (this.$data.featureImage == "" || this.$data.featureImage == null) {
        this.$vs.notify({
          text: "Feature Image Require",
          color: "warning",
          position: "top-right",
        });
        return;
      }
      if (!this.$data.isNew && !this.$data.clone) {
        let data = this.$data.cat;
        // if (data.position == "") {
        //   this.$vs.notify({
        //     text: "God Position Number Require",
        //     color: "warning",
        //     position: "top-right",
        //   });
        //   return;
        // }
        this.btnUpdateGod();
      } else if (this.$data.clone) {
        let data = {
          name: this.$data.cat.name,
          image: this.$data.cat.image,
          position: this.$data.cat.position,
          language: this.$data.cat.language,
          featureImage: this.$data.cat.featureImage,
          moveTop: this.$data.cat.moveTop,
          moveBottom: this.$data.cat.moveBottom,
        };
        this.addMusicRecord(data);
      } else {
        let data = this.$data.cat;

        data["image"] = this.$data.displayImage;
        data["featureImage"] = this.$data.featureImage;

        let fieldName = "";
        if (data.image == "") {
          fieldName = "God Image";
        }
        if (data.language == "") {
          fieldName = "Category Language";
        }
        if (data.featureImage == "") {
          fieldName = "Feature Image";
        }
        // if (data.position == "") {
        //   fieldName = "God Position Number";
        // }
        if (data.name == "") {
          fieldName = "God Name";
        }

        if (data.name == "" || data.image == "") {
          this.$vs.notify({
            text: fieldName + " Require",
            color: "warning",
            position: "top-right",
          });
          return;
        }
        this.addMusicRecord(data);
      }
    },
    async createAndTranslate() {
      let data = this.$data.cat;

      data["image"] = this.$data.displayImage;
      data["featureImage"] = this.$data.featureImage;

      if (data.name == "" || data.image == "") {
        this.$vs.notify({
          text: "God Name and God Image Require",
          color: "warning",
          position: "top-right",
        });
        return;
      }

      this.$data.showLoader = true;
      this.$data.defaultalert = false;

      const res = await api.post(API.C_AND_T_GOD, data);
      try {
        this.$vs.loading.close();
        if (res.status == 200) {
          this.$vs.notify({
            text: "Saved Successfully",
            color: "success",
            position: "top-right",
          });
          this.$data.isNew = true;
          this.$data.itemToUpdate = "";
          this.$data.defaultalert = false;
          (this.$data.cat = {
            // status: true,
            language: "",
            position: "",
            name: "",
            image: "",
            moveTop: false,
            moveBottom: false,
          }),
            this.fetchAllCategory();
          this.$data.showLoader = false;
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: r.data.error,
          color: "danger",
          position: "top-right",
        });
        this.$data.showLoader = false;
        throw error;
      }
    },

    async updateAndTranslate() {
      let data = this.$data.cat;
      let id = this.$data.cat._id;
      data["image"] = this.$data.displayImage;
      data["featureImage"] = this.$data.featureImage;

      this.$data.showLoader = true;
      this.$data.defaultalert = false;

      const r = await api.put(`${API.U_AND_T_GOD}/${id}`, data);
      try {
        if (r.status == 200) {
          this.$vs.notify({
            text: "Updated Successfully",
            color: "success",
            position: "top-right",
          });
          this.$data.isNew = true;
          this.$data.itemToUpdate = "";
          this.$data.defaultalert = false;
          (this.$data.cat = {
            // status: true,
            language: "",
            position: "",
            name: "",
            image: "",
            moveTop: false,
            moveBottom: false,
          }),
            this.fetchAllCategory();
          this.$data.showLoader = false;
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: r.data.error,
          color: "danger",
          position: "top-right",
        });
        this.$data.showLoader = false;
        throw error;
      }
    },

    addMusicRecord(data) {
      this.$vs.loading();
      api
        .post(API.INSERT_GOD, data)
        .then((r) => {
          this.$vs.loading.close();
          if (r.status == 200) {
            this.$vs.notify({
              text: "Saved Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            (this.$data.cat = {
              // status: true,
              language: "",
              position: "",
              name: "",
              image: "",
            }),
              this.fetchAllCategory();
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    uploadImage(data, item) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      var isValid = false;
      isValid = imageType.indexOf(data.target.files[0].type) > -1;

      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        this.$refs.fileInput.value = null;
        return;
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      let formdata = new FormData();
      this.$data.fileName = data.target.files[0].name;
      formdata.append("file", data.target.files[0]);
      formdata.append("god", this.$data.cat.name);
      this.$vs.loading();
      api
        .post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
          } else {
            const data = response;
            if (item == "featureImage") {
              this.$data.featureImage = response.data.files[0].url;
            } else {
              this.$data.displayImage = response.data.files[0].url;
            }
            if (response) {
              this.$vs.notify({
                text: "File Uploaded",
                color: "success",
                position: "top-right",
              });
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                text: "File Uploading Failed",
                color: "danger",
                position: "top-right",
              });
            }
            this.$refs.fileInput.value = null;
            this.$emit("input", data);
          }
        })
        .catch(() => {});
      this.$vs.loading.close();
    },
    btnUpdateGod() {
      this.$vs.loading();
      let data = this.$data.cat;
      let id = this.$data.cat._id;
      data["image"] = this.$data.displayImage;
      data["featureImage"] = this.$data.featureImage;

      api
        .put(API.UPDATE_GOD, data, { params: { id: id } })
        .then((r) => {
          this.$vs.loading.close();
          if (r.status == 200) {
            this.$vs.notify({
              text: "Updated Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            (this.$data.cat = {
              // status: true,
              language: "",
              // position: "",
              name: "",
              image: "",
            }),
              this.fetchAllCategory();
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    deleteImage() {
      this.$data.displayImage = "";
    },
    deleteFeatureImage() {
      this.$data.featureImage = "";
    },
    fileterusingSort(event) {
      this.$data.search.sort = event;
      this.fetchAllCategory();
    },
    fileterusingLanguage(event) {
      this.$data.search.language = event;
      this.fetchAllCategory();
    },
    fetchAllCategory() {
      this.$vs.loading();
      api
        .get(API.GET_GODS_DASH, { params: { position: this.$data.search.sort, language: this.$data.search.language } })
        .then((r) => {
          this.$vs.loading.close();

          if (this.$data.search.language === "EN") {
            for (const item of r.data) {
              item.tooltipContent =
                item.missingLanguages.length > 0 ? "Missing Languages: " + item.missingLanguages.join(", ") : "All Languages are translated";
            }
          }

          this.$data.all = r.data;
          if (r.status != 200) {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {});
    },
    async deleteCategory() {
      let id = this.$data.itemToDelete._id;

      const r = await api.delete(API.DELETE_GOD, { params: { id: id } });

      try {
        if (r.status == 200) {
          this.$vs.notify({
            text: "Deleted Successfully",
            color: "success",
            position: "top-right",
          });
        } else {
          this.$vs.notify({
            text: "Already Deleted",
            color: "danger",
            position: "top-right",
          });
        }
        this.$data.deleteCategoryPopup = false;
        this.fetchAllCategory();
      } catch (error) {
        this.$vs.notify({
          text: "Error Deleting",
          color: "danger",
          position: "top-right",
        });
        this.$vs.loading.close();
      }
    },
    async fileterusingLanguages(event, item) {
      try {
        let id = item.ref || item._id;
        if (event && id) {
          let headers = {
            "Content-Type": "application/json;charset=utf-8",
          };
          if (JSON.parse(localStorage.user).token) {
            headers["token"] = this.$data.token;
          }
          this.$vs.loading();
          const res = await api.get(`${API.GET_SINGLE_GOD}/${id}?language=${event}`, { headers });
          this.$data.cat = Object.assign({}, res.data);
          this.$data.displayImage = res.data.image;
          this.$data.featureImage = res.data.featureImage;
          this.searchData();
          this.$vs.loading.close();
        }
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Error",
          text: "Translation not found for this category.",
          color: "danger",
          position: "top-right",
        });
        this.$data.cat = this.$data.englishData;
      }
    },
    fetchAllLanguages() {
      this.$vs.loading();
      api
        .get(API.GET_LANG, {})
        .then((r) => {
          this.$vs.loading.close();
          this.$data.languages = r.data;
        })
        .catch(() => {});
    },
    searchData() {
      this.$vs.loading();

      api
        .get(`${API.GET_GOD}?position=${this.$data.search.sort}&language=${this.$data.search.language}&status=${this.$data.search.status}`)
        .then((r) => {
          this.$vs.loading.close();

          for (const item of r.data) {
            item.tooltipContent =
              item.missingLanguages.length > 0 ? "Missing Languages: " + item.missingLanguages.join(", ") : "All Languages are translated";
          }

          this.$data.all = r.data;
          if (!r.status == 200) {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {});
    },
    resetData() {
      this.fetchAllCategory();
      // this.$data.sorting = "1";
      this.$data.search = {
        sort: 1,
        language: "EN",
        status: "0",
      };
    },
    viewAllPosts(i) {
      this.$router.push("/musiclistDisplay/" + i._id + "?catLang=" + i.language + "&catName=" + i.name);
    },
  },
  created() {
    this.fetchAllCategory();
    this.fetchAllLanguages();
  },
};
</script>
<style scoped>
.loader-container {
  background-color: gray;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  padding-right: 1rem;
  padding-left: 1rem;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.loader {
  border: 2px solid white;
  border-top: 2px solid red;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

.loader-text {
  color: white;
  text-align: center;
  font-size: 1.2rem;
  margin-top: 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.mb15 {
  margin-bottom: 15px;
}

.mr15 {
  margin-right: 15px;
}

.td {
  vertical-align: middle;
}

.mt20 {
  margin-top: 20px;
}

.searchBtn {
  margin-top: 25px;
  margin-right: 5px;
  width: 30%;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  cursor: pointer !important;
}

.btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 0.4rem;
  border-radius: 0px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.progress-bar-container {
  width: 100%;
  background-color: #f3f3f3;
  border: 1px rgba(0, 0, 0, 0.068) solid;
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 5px;
}

.progress-bar {
  height: 10px;
  transition: width 0.3s ease;
}

.absoluteText {
  text-align: start;
}
</style>
